import { FC, useContext } from 'react';
import {
  Associate,
  AuthenticationContext,
  IntroModuleAsPost,
  Post,
  useGetAssociateIntroModulesAsPosts,
} from '@vs-online-only-app/state';
import { Stack } from '@mui/material';
import { PostSkeleton } from './PostsList';
import PostCard from './PostCard';

const convertIntroModulesToPosts = (
  introModulePosts: IntroModuleAsPost[],
  user?: Associate,
): Post[] =>
  introModulePosts.map((introModule) => ({
    _id: introModule._id,
    title: introModule.title,
    body: introModule.body,
    author: {
      avatar: introModule.author.avatar,
      name: introModule.author.name,
    },
    media: [
      {
        type: 'image/png',
        name: introModule.title,
        url: introModule.placeHolderUrl,
      },
    ],
    publishedAt: null,
    createdAt: new Date().toISOString(),
    modifiedAt: new Date().toISOString(),
    unpublishAt: null,
    retailer: user?.retailer || '',
    status: 'published',
    analytics: {
      deliveries: 0,
      uniqueDeliveries: 0,
      deliveredTo: [],
      reads: 0,
      uniqueReads: 0,
      readBy: user && introModule.isRead ? [user.id] : [],
    },
  }));

const IntroModulesAsPosts: FC = () => {
  const { user } = useContext(AuthenticationContext);
  const { data, isLoading } = useGetAssociateIntroModulesAsPosts();
  const posts = data?.introPosts || [];

  const convertedPosts: Post[] = convertIntroModulesToPosts(posts, user);

  return (
    <Stack gap={2} overflow="auto" paddingBottom={3}>
      {isLoading
        ? Array.from({ length: 3 }).map((_, index) => (
            <PostSkeleton key={index} variant="rectangular" />
          ))
        : convertedPosts.map((post) => <PostCard key={post._id} {...post} />)}
    </Stack>
  );
};

export default IntroModulesAsPosts;
